module.exports = __webpack_public_path__ + "pf1-16e94c5925aefb597e45d019a3fbc736.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/pf1.png
// module id = /Blj
// module chunks = client